import { Component } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FreeTierDialog } from './free-tier-dialog.component';
import { PlanGateService } from '../services/plan-gate.service';

@Component({
  selector: 'app-usage',
   standalone: false,
  templateUrl: './usage.component.html',
  styleUrl: './usage.component.css'
})
export class UsageComponent {

    apiKey: any;
    status: any;
    workspaceName: any;
    usage:any;
    userBreakdown:any;
    spdate:any;
    loading = true;
    displayedColumns: string[] = [
    "userKey",
    "tokensused",
    "recipesused",
  ];

  constructor(
      public appService: AppService, 
      private router: Router,
      private dialog: MatDialog,
      private planGate: PlanGateService
    ) {}


ngOnInit(): void {
    this.loading = true;
    this.getUsage();
  }

  payments(){
    this.router.navigate(['/payments']);
  }

  async getUsage() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.status = ws.status;
          this.workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      }       

      const activationPayload: any = {    
        routeType:"UI_SESSION"    
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "usage/connector-summary",
        this.apiKey,
        signature
      );
      this.loading = false;
      if (response && response?.status === "Success") {
        this.usage = response?.data;
        this.spdate = response?.data?.startPeriod * 1000;
        
        this.planGate.applySummary(this.usage);

        // The soft nudge only applies while there is still allowance left -
        // once it runs out PlanGateService takes over with the hard block.
        if (!this.planGate.blocked && this.usage?.tier && this.usage.tier.toLowerCase() === 'free') {
          this.showFreeTierDialog();
        }
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      this.loading = false;
      console.error("Error in getUsage:", error);
    }
  }

  showFreeTierDialog(): void {
    const dialogRef = this.dialog.open(FreeTierDialog, {
      width: '500px',
      disableClose: false,
      // The allowance comes from the tier table, so quote the live number
      // rather than whatever it happened to be when this copy was written.
      data: { freeLimit: this.usage?.monthlyLimit }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'upgrade') {
        this.router.navigate(['/subscription']);
      }
    });
  }

}